import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'
import { responsiveImageFragment } from '../fragments/images'

export const ambitoPage = gql`
  ${seoFragment}
  ${responsiveImageFragment}
  query AmbitoPage($locale: SiteLocale, $slug: String) {
    listaAmbiti(locale: $locale, filter: { slug: { eq: $slug } }) {
      seo {
        ...SeoFragment
      }
      _allSlugLocales {
        value
        locale
      }
      titolo
      slug
      body {
        ... on BloccoImmagineTesto1Record {
          id
          landscape: immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
          portrait: immagine {
            responsiveImage(
              imgixParams: { auto: compress, q: "50", ar: "1:1", fit: crop }
            ) {
              ...ResponsiveImageFragment
            }
          }
          testo
          titolo
        }
        ... on IntroPagineRecord {
          id
          testoSinistra
          testoDestra
          titolo
        }
        ... on PrimoBloccoContenutiRecord {
          id
          titolo
          testo
        }
      }
      bloccoSovrapposto {
        titoloSinistra
        testoDestra
        cta {
          testo
          link
        }
      }
      serviziPerAmbito {
        titolo
        slug
      }
    }
  }
`

export const ambitiData = gql`
  ${seoFragment}
  query AmbitiData($locale: SiteLocale) {
    ambiti(locale: $locale) {
      seo {
        ...SeoFragment
      }
      titolo
      slug
      intro {
        testoSinistra
        testoDestra
        titolo
      }
    }
    allListaAmbitis(locale: $locale) {
      _allSlugLocales {
        value
        locale
      }
      slug
      titolo
    }
  }
`
